/** Full navigation to Mollie (or other) hosted checkout URL. */
export function redirectToCheckout(url) {
  if (typeof url !== "string" || url.length === 0) return;
  location.assign(url);
}
